<template>
    <div class="contact-us content-wrapper">
        <div class="title-wrapper">
            <span class="bracket-wrapper">
                <img class="bracket" src="~@/assets/celtic_bracket.png" />
            </span>
            <h1 class="title">
                Get in Touch
            </h1>
            <span class="bracket-wrapper left">
                <img class="bracket flipped" src="~@/assets/celtic_bracket.png" />
            </span>
        </div>
        <div class="content">
            <form class="form" v-on:submit.prevent="onSubmit">
                <div class="form-control-wrapper">
                    <input
                        class="form-control"
                        v-model="form.name"
                        placeholder="Name"
                        name="name"
                        autocomplete="off"
                        @input="onInputChange"
                        :class="{ 'disabled': sending }"
                        :disabled="sending"
                    />
                    <div class="form-error" v-if="errors.name">
                        {{ errors.name }}
                    </div>
                </div>
                <div class="form-control-wrapper">
                    <input
                        class="form-control"
                        v-model="form.email"
                        placeholder="Email (optional)"
                        name="email"
                        autocomplete="off"
                        @input="onInputChange"
                        :class="{ 'disabled': sending }"
                        :disabled="sending"
                    />
                    <div class="form-error" v-if="errors.email">
                        {{ errors.email }}
                    </div>
                </div>
                <div class="form-control-wrapper">
                    <textarea
                        class="form-control textarea"
                        v-model="form.message"
                        placeholder="Message"
                        name="message"
                        autocomplete="off"
                        @input="onInputChange"
                        :class="{ 'disabled': sending }"
                        :disabled="sending"
                    />
                    <div class="form-error" v-if="errors.message">
                        {{ errors.message }}
                    </div>
                </div>
                <div class="form-control-wrapper">
                    <button class="btn btn-primary btn-block" v-if="!sending">
                        Send
                    </button>
                    <button class="btn btn-disabled btn-block sending-btn" v-if="sending">
                        <spinner
                            class="spinner-wrapper"
                            size="small"
                            line-fg-color="#b5b5b5"
                            :speed="1.2"
                        />
                        <span class="sending-btn-label">Sending...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import api from '../../helpers/api';

export default {
    name: 'Contact',
    data() {
        return {
            show: false,
            form: {
                email: '',
                message: '',
                name: '',
            },
            errors: {
                email: null,
                message: null,
                name: null,
            },
            sending: false,
        };
    },
    methods: {
        validateEmail(email) {
            return !email || /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/i.test(email);
        },
        validateMessage(text) {
            return text.length;
        },
        validateName(name) {
            return name.length;
        },
        validateForm(form) {
            const { email, message, name } = form;
            const { errors } = this;

            const emailMsg = 'Please enter a valid email.';
            const messageMsg = 'Please enter a message.';
            const nameMsg = 'Please enter your name or a nickname.';

            errors.email = !this.validateEmail(email) ? emailMsg : null;
            errors.message = !this.validateMessage(message) ? messageMsg : null;
            errors.name = !this.validateName(name) ? nameMsg : null;

            return !errors.email && !errors.message && !errors.name;
        },
        onInputChange(event) {
            const { name, value } = event.target;
            const capitalizedName = name.slice(0, 1).toUpperCase() + name.slice(1);

            if (this.errors[name]) {
                if (this[`validate${capitalizedName}`](value)) {
                    this.errors[name] = null;
                }
            }
        },
        async onSubmit() {
            const { form } = this;

            if (!this.validateForm(form)) {
                return;
            }

            this.sending = true;

            const response = await api.request('/contact/send', 'POST', this.form);

            if (response.ok) {

                this.$notify({
                    group: 'app',
                    title: 'Success',
                    type: 'success',
                    text: 'Message successfully sent!',
                });

                this.form.email = '';
                this.form.message = '';
                this.form.name = '';
                this.sending = false;
                return;
            }

            this.sending = false;

            const error = await response.json();

            this.$notify({
                group: 'app',
                title: 'Error',
                type: 'error',
                text: error.message,
            });
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .contact-us {

        .content {
            margin: 35px auto 0;
            font-size: 1.1em;
        }

        .textarea {
            height: 135px;
        }

        .form-control {

            &.disabled {
                background-color: $light-gray;
                cursor: default;
            }
        }

        .sending-btn {

            .spinner-wrapper {
                display: inline-block;
                vertical-align: middle;
            }

            .sending-btn-label {
                vertical-align: middle;
                margin-left: 5px;
            }
        }

    }

    @media only screen and (min-width: $screen-sm) {

        .contact-us {

            .content {
                max-width: 350px;
            }

            .title-wrapper {

                .title {
                    font-size: 3.5em;
                    max-width: none;
                }
            }
        }
    }

</style>
